<template>
  <div class="admin-organization-switcher">
    <div class="admin-organization-switcher__title">
      {{ $t("admin_organization_switcher.title") }}
    </div>
    <el-select
      v-model="selectedOrg.id"
      filterable
      remote
      :remote-method="remoteMethod"
      placeholder="Search"
    >
      <el-option v-for="(item, index) in filterOrgs" :key="index" :label="item.name" :value="item.id">
        <div v-if="item.branch_type === 'parent'" class="dropdown-item__org-name" @click="handleClick(item)">
          <div>
            {{ item.name }}
            <span>{{ $t("admin_organization_switcher.organization") }}</span>
          </div>
          <img v-if="item.id === selectedOrg.id" :src="checkBlue" />
        </div>
        <div
          v-else
          class="dropdown-item__branch-name"
          :class="{
            'dropdown-item__branch-name--selected': item.id === selectedOrg.id,
          }"
          @click="handleClick(item)"
        >
          {{ item.name }}
          <img v-if="item.id === selectedOrg.id" :src="checkBlue" />
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import checkBlue from "@/assets/images/check-blue.svg";
import { both, chain, clone, compose, filter, includes, prop, propEq, propSatisfies, sortBy, toLower } from "ramda";

export default {
  data() {
    return {
      checkBlue,
      isShown: false,
      loading: false,
      filterOrgs: [],
    };
  },
  computed: {
    selectedOrg() {
      return this.$store.state.organization.currentOrganization;
    },
    ...mapGetters("organization", ["organizationsFilter"]),
    sortedOrganization() {
      const filteredParents = filter(propEq("branch_type", "parent"), this.organizationsFilter);
      const sortedParents = sortBy(compose(toLower, prop("name")), filteredParents);

      return chain(parent => {
        const parentId = parent.id;
        const filteredChildren = filter(
          both(propEq("branch_type", "child"), propEq("parent", parentId)),
          this.organizationsFilter
        );
        const sortedChildren = sortBy(compose(toLower, prop("name")), filteredChildren);
        const updatedParent = clone(parent);

        return [updatedParent, ...sortedChildren];
      }, sortedParents);
    },
  },
  mounted() {
    this.filterOrgs = this.sortedOrganization;
  },
  methods: {
    handleClick(org) {
      const path = this.$route.fullPath;
      const currOrganization = this.$route.params.organizationId;
      window.location = path.replace(currOrganization, org.id);
    },
    remoteMethod(searchTerm) {
      if (searchTerm !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.filterOrgs = filter(
            both(propEq("branch_type", "parent"), propSatisfies(includes(searchTerm), "name")),
            this.sortedOrganization
          );
        }, 200);
      } else {
        this.filterOrgs = this.sortedOrganization;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-organization-switcher {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  background: #f9f9f9;

  &__title {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.25px;
    color: #575579;
    margin-right: 1rem;
  }
}

.el-dropdown {
  padding-right: 2rem;
}

.el-dropdown-menu {
  height: 390px;
  overflow: hidden scroll;
  padding: 0px 0;
  &__item {
    padding: 0.3rem 0.3rem;
    width: 15rem;
  }
}

::v-deep .el-input__inner {
  font-size: 14px;
  font-weight: 700;
  color: #478dff;
  border-radius: 0.5rem;
  &:focus {
    font-size: 14px;
    font-weight: 700;
    color: #478dff;
    border: 1px solid #478dff;
  }
}

.el-select-dropdown__item {
  height: auto;
  padding: 5px 20px;
  min-width: 250px;
}

.dropdown-item__org-name {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.20000000298023224px;
  color: #121131;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: block;
    line-height: 12px;
    color: #8181a5;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.20000000298023224px;
  }
}

.dropdown-item__branch-name {
  padding-left: 2rem;
  color: #8181a5;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &--selected {
    color: #121131;
  }
}
</style>
